import React, { forwardRef } from "react";

import { ITypographyProps, Typography } from "../Typography";

export const Header3 = forwardRef<
  HTMLDivElement,
  Omit<ITypographyProps, "weight" | "variant">
>(({ children, ...props }, ref) => {
  return (
    <Typography weight="bold" variant="Header 3" ref={ref} {...props}>
      {children}
    </Typography>
  );
});

Header3.displayName = "Header3";
